/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfAuditVm } from '../models/custom-result-of-audit-vm';
import { CustomResultOfListOfGetPlansTypeModuleDto } from '../models/custom-result-of-list-of-get-plans-type-module-dto';
import { CustomResultOfListOfMenuClaimDto } from '../models/custom-result-of-list-of-menu-claim-dto';
import { CustomResultOfListOfPlanListItemForBuyDto } from '../models/custom-result-of-list-of-plan-list-item-for-buy-dto';
import { CustomResultOfPaginatedListOfPlanListItemDto } from '../models/custom-result-of-paginated-list-of-plan-list-item-dto';
import { CustomResultOfPlanDetails } from '../models/custom-result-of-plan-details';
import { CustomResultOfPlanMenusDto } from '../models/custom-result-of-plan-menus-dto';
import { plansBuyPlan } from '../fn/plans/plans-buy-plan';
import { PlansBuyPlan$Params } from '../fn/plans/plans-buy-plan';
import { plansCreateGet } from '../fn/plans/plans-create-get';
import { PlansCreateGet$Params } from '../fn/plans/plans-create-get';
import { plansCreatePost } from '../fn/plans/plans-create-post';
import { PlansCreatePost$Params } from '../fn/plans/plans-create-post';
import { plansDelete } from '../fn/plans/plans-delete';
import { PlansDelete$Params } from '../fn/plans/plans-delete';
import { plansGetPlan } from '../fn/plans/plans-get-plan';
import { PlansGetPlan$Params } from '../fn/plans/plans-get-plan';
import { plansGetPlansAudit } from '../fn/plans/plans-get-plans-audit';
import { PlansGetPlansAudit$Params } from '../fn/plans/plans-get-plans-audit';
import { plansGetPlansTypeModule } from '../fn/plans/plans-get-plans-type-module';
import { PlansGetPlansTypeModule$Params } from '../fn/plans/plans-get-plans-type-module';
import { plansGetPlansTypePackage } from '../fn/plans/plans-get-plans-type-package';
import { PlansGetPlansTypePackage$Params } from '../fn/plans/plans-get-plans-type-package';
import { plansGetPlansWithPagination } from '../fn/plans/plans-get-plans-with-pagination';
import { PlansGetPlansWithPagination$Params } from '../fn/plans/plans-get-plans-with-pagination';
import { plansUpdateGet } from '../fn/plans/plans-update-get';
import { PlansUpdateGet$Params } from '../fn/plans/plans-update-get';
import { plansUpdatePut } from '../fn/plans/plans-update-put';
import { PlansUpdatePut$Params } from '../fn/plans/plans-update-put';

@Injectable({ providedIn: 'root' })
export class PlansService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `plansGetPlansAudit()` */
  static readonly PlansGetPlansAuditPath = '/Plans/GetPlansAudit';

  /**
   * Only for super admin, Get all audit logs, startDate and endDate is UTC LocalTime.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `plansGetPlansAudit()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  plansGetPlansAudit$Response(params: PlansGetPlansAudit$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVm>> {
    return plansGetPlansAudit(this.http, this.rootUrl, params, context);
  }

  /**
   * Only for super admin, Get all audit logs, startDate and endDate is UTC LocalTime.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `plansGetPlansAudit$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  plansGetPlansAudit(params: PlansGetPlansAudit$Params, context?: HttpContext): Observable<CustomResultOfAuditVm> {
    return this.plansGetPlansAudit$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVm>): CustomResultOfAuditVm => r.body)
    );
  }

  /** Path part for operation `plansGetPlansWithPagination()` */
  static readonly PlansGetPlansWithPaginationPath = '/Plans/GetPlansWithPagination';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `plansGetPlansWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  plansGetPlansWithPagination$Response(params: PlansGetPlansWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfPlanListItemDto>> {
    return plansGetPlansWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `plansGetPlansWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  plansGetPlansWithPagination(params: PlansGetPlansWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfPlanListItemDto> {
    return this.plansGetPlansWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfPlanListItemDto>): CustomResultOfPaginatedListOfPlanListItemDto => r.body)
    );
  }

  /** Path part for operation `plansCreateGet()` */
  static readonly PlansCreateGetPath = '/Plans/Create';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `plansCreateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  plansCreateGet$Response(params?: PlansCreateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfMenuClaimDto>> {
    return plansCreateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `plansCreateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  plansCreateGet(params?: PlansCreateGet$Params, context?: HttpContext): Observable<CustomResultOfListOfMenuClaimDto> {
    return this.plansCreateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfMenuClaimDto>): CustomResultOfListOfMenuClaimDto => r.body)
    );
  }

  /** Path part for operation `plansCreatePost()` */
  static readonly PlansCreatePostPath = '/Plans/Create';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `plansCreatePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  plansCreatePost$Response(params: PlansCreatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return plansCreatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `plansCreatePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  plansCreatePost(params: PlansCreatePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.plansCreatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `plansUpdateGet()` */
  static readonly PlansUpdateGetPath = '/Plans/Update/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `plansUpdateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  plansUpdateGet$Response(params: PlansUpdateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPlanMenusDto>> {
    return plansUpdateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `plansUpdateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  plansUpdateGet(params: PlansUpdateGet$Params, context?: HttpContext): Observable<CustomResultOfPlanMenusDto> {
    return this.plansUpdateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPlanMenusDto>): CustomResultOfPlanMenusDto => r.body)
    );
  }

  /** Path part for operation `plansUpdatePut()` */
  static readonly PlansUpdatePutPath = '/Plans/Update/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `plansUpdatePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  plansUpdatePut$Response(params: PlansUpdatePut$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return plansUpdatePut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `plansUpdatePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  plansUpdatePut(params: PlansUpdatePut$Params, context?: HttpContext): Observable<CustomResult> {
    return this.plansUpdatePut$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `plansDelete()` */
  static readonly PlansDeletePath = '/Plans/Delete/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `plansDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  plansDelete$Response(params: PlansDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return plansDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `plansDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  plansDelete(params: PlansDelete$Params, context?: HttpContext): Observable<CustomResult> {
    return this.plansDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `plansGetPlansTypeModule()` */
  static readonly PlansGetPlansTypeModulePath = '/Plans/GetPlansTypeModule';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `plansGetPlansTypeModule()` instead.
   *
   * This method doesn't expect any request body.
   */
  plansGetPlansTypeModule$Response(params?: PlansGetPlansTypeModule$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetPlansTypeModuleDto>> {
    return plansGetPlansTypeModule(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `plansGetPlansTypeModule$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  plansGetPlansTypeModule(params?: PlansGetPlansTypeModule$Params, context?: HttpContext): Observable<CustomResultOfListOfGetPlansTypeModuleDto> {
    return this.plansGetPlansTypeModule$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetPlansTypeModuleDto>): CustomResultOfListOfGetPlansTypeModuleDto => r.body)
    );
  }

  /** Path part for operation `plansGetPlansTypePackage()` */
  static readonly PlansGetPlansTypePackagePath = '/Plans/GetPlansTypePackage';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `plansGetPlansTypePackage()` instead.
   *
   * This method doesn't expect any request body.
   */
  plansGetPlansTypePackage$Response(params?: PlansGetPlansTypePackage$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfPlanListItemForBuyDto>> {
    return plansGetPlansTypePackage(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `plansGetPlansTypePackage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  plansGetPlansTypePackage(params?: PlansGetPlansTypePackage$Params, context?: HttpContext): Observable<CustomResultOfListOfPlanListItemForBuyDto> {
    return this.plansGetPlansTypePackage$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfPlanListItemForBuyDto>): CustomResultOfListOfPlanListItemForBuyDto => r.body)
    );
  }

  /** Path part for operation `plansGetPlan()` */
  static readonly PlansGetPlanPath = '/Plans/GetPlan';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `plansGetPlan()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  plansGetPlan$Response(params: PlansGetPlan$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPlanDetails>> {
    return plansGetPlan(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `plansGetPlan$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  plansGetPlan(params: PlansGetPlan$Params, context?: HttpContext): Observable<CustomResultOfPlanDetails> {
    return this.plansGetPlan$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPlanDetails>): CustomResultOfPlanDetails => r.body)
    );
  }

  /** Path part for operation `plansBuyPlan()` */
  static readonly PlansBuyPlanPath = '/Plans/BuyPlan';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `plansBuyPlan()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  plansBuyPlan$Response(params: PlansBuyPlan$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return plansBuyPlan(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `plansBuyPlan$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  plansBuyPlan(params: PlansBuyPlan$Params, context?: HttpContext): Observable<CustomResult> {
    return this.plansBuyPlan$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

}
